import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

export const MatchTeamQuerySchema = PaginationRequestSchema.extend({
  disciplineId: z.string().optional(),
  subCategoryId: z.string().optional(),
  name: z.string().optional(),
  createdFrom: z.string().optional(),
  createdTo: z.string().optional(),
  id: z.string().optional(),
});
export type MatchTeamQueryDTO = z.infer<typeof MatchTeamQuerySchema>;

export const CreateMatchTeamRequestSchema = z.object({
  disciplineId: z.string().min(1, "La disciplina es requerida"),
  subCategoryIds: z.array(z.string()).optional(),
  name: z.string().min(1, "El nombre del equipo es requerido"),
  description: z.string().optional(),
  imageUrl: z.string().url("URL de imagen inválida").optional(),
});
export type CreateMatchTeamRequestDTO = z.infer<typeof CreateMatchTeamRequestSchema>;

export const UpdateMatchTeamRequestSchema = z.object({
  disciplineId: z.string().optional(),
  subCategoryIds: z.array(z.string()).optional(),
  name: z.string().min(1).optional(),
  description: z.string().optional(),
  imageUrl: z.string().url("URL de imagen inválida").nullable().optional(),
});
export type UpdateMatchTeamRequestDTO = z.infer<typeof UpdateMatchTeamRequestSchema>;

export const MatchTeamResponseSchema = z.object({
  id: z.string(),
  disciplineId: z.string(),
  disciplineName: z.string().nullable(),
  subCategoryIds: z.array(z.string()),
  subCategoryNames: z.array(z.string()),
  name: z.string(),
  description: z.string().nullable(),
  imageUrl: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type MatchTeamResponseDTO = z.infer<typeof MatchTeamResponseSchema>;

export const MatchTeamsPaginatedResponseSchema = PaginationResponseSchema(MatchTeamResponseSchema);
export type MatchTeamsPaginatedResponseDTO = z.infer<typeof MatchTeamsPaginatedResponseSchema>;
